// removed by extract-text-webpack-plugin
module.exports = {"task":"SCW-tFx5tXj8Fog2fdmon","title":"_2Qxe_I0yK5vIocCYNb5ueR","status":"_3cVmu7obGVYNslpoMr97F0","green":"_3OhasfX97e52OPz--PCaw_","grey":"_25joRcyV5UAYyACNpiM-DP","yellow":"_3ISDajIsUQRbYIS-rLdJf4","red":"_3LY1y0w314-HyjPoqSw4vI","tag":"M-gQxbBugPz8nz_gaZTxa","left":"_3S9gRrZV4mQr3UjD6xJBxS","right":"_1VkKpVl1Gs23GVoVELgF2y","removed":"ofaOLJ4pH3lOYR0gpMpBs"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Task/style.scss
// module id = 1058
// module chunks = 0